module.exports = __webpack_public_path__ + "static/media/target-dummy.97ba6984.svg";